module.exports = __webpack_public_path__ + "img/swab_icon.ae14b0a5.png";